import axiosInstance from './axiosInstance';

export const GetPaymentById = async (payment_id) => {
  try {
    const { data } = await axiosInstance.get(`/Payment/Data/${payment_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getJournalById = async (journal_id) => {
  try {
    const { data } = await axiosInstance.get(`/journalledger/Data/${journal_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPaymentDetail_Pay = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/payment/payment/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllPaymentDetail = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/payment/receipt/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getAllJournals = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/journalledger/store/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const addPayment = async (acc_from_id, acc_to_id, type_id, amt_paid, datetime, notes) => {
  try {
    const { data } = await axiosInstance.post(`/payment`, {
      acc_from_id: acc_from_id,
      acc_to_id: acc_to_id,
      type_id: type_id,
      amount_paid: amt_paid,
      datetime: datetime,
      note: notes,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const editPayment = async (payment_id, acc_from_id, acc_to_id, type_id, amount_paid, datetime, acc_notes) => {
  try {
    const { data } = await axiosInstance.put(`/payment/${payment_id}`, {
      acc_from_id: acc_from_id,
      acc_to_id: acc_to_id,
      type_id: type_id,
      amount_paid: amount_paid,
      datetime: datetime,
      note: acc_notes,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const deletePayment = async (payment_id) => {
  try {
    const { data } = await axiosInstance.delete(`/payment/${payment_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const deleteJournalById = async (journal_id) => {
  try {
    const { data } = await axiosInstance.delete(`/journalledger/${journal_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const addJournalApi = async (ledgers) => {
  try {
    const { data } = await axiosInstance.post(`/JournalLedger`, { ledgers: ledgers });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const editJournalApi = async (journal_id, ledgers) => {
  try {
    const { data } = await axiosInstance.put(`/journalledger/${journal_id}`, { ledgers: ledgers });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
